import React, { useRef, useEffect } from "react";
import defaultSound from "@public/sound/bip.mp3";


export default function Sound({ path=defaultSound }) {
  const audio = useRef(null);

  useEffect(() => {
    audio.current?.play();
  }, []);

  return (
    <audio ref={audio} autoPlay>
      <source src={path}></source>
      Audio element not supported.
    </audio>
  );
};

